import { id } from "@volkswagen-onehub/gfa-navigation-service";
import { NavigationServiceV1Impl } from "./v1/navigation-service-v1";
export function defineNavigationService(options) {
    return {
        id: "navigation-service",
        dependencies: { featureServices: { "s2:history": "^2.0.0" } },
        optionalDependencies: { featureServices: { "s2:logger": "^1.0.0" } },
        create: env => {
            const { "s2:history": historyService, "s2:logger": logger = console } = env.featureServices;
            const { pages, primaryConsumerId, primaryConsumerLocation, onNavigate } = options;
            return {
                "1.3.0": (consumerId, consumerName) => {
                    const navigationService = new NavigationServiceV1Impl(historyService, logger, {
                        pages,
                        primaryConsumerId,
                        primaryConsumerLocation,
                        onNavigate: (pageId) => {
                            if (onNavigate) {
                                onNavigate(consumerId, consumerName, pageId);
                            }
                        }
                    });
                    return {
                        featureService: navigationService
                    };
                }
            };
        }
    };
}
export function defineGfaNavigationService() {
    return {
        id,
        dependencies: {
            featureServices: {
                "navigation-service": "^1.2.0"
            }
        },
        create: env => {
            const navigationService = env.featureServices["navigation-service"];
            return {
                "1.0.0": () => ({
                    featureService: navigationService
                })
            };
        }
    };
}
export const defineNavigationServices = (options) => [
    defineGfaNavigationService(),
    defineNavigationService(options)
];
